import { Stack, Typography } from '@mui/material'
import * as sxStyles from '../AnalyticsDetails.styled'
import Grid from '@mui/material/Grid2'
import { CardWithTitle } from './CardWithTitle'
import { AdsClick } from '@mui/icons-material'

export const DeliveryEmptyState = () => {
  return (
    <Stack sx={sxStyles.mainGrid}>
      <Grid size={12}>
        <CardWithTitle title="Analysis Results" />
      </Grid>
      <Stack
        sx={{
          alignItems: 'center',
          justifyContent: 'center',
          height: '100%',
          width: '100%',
          gap: 1,
        }}
      >
        <AdsClick fontSize="large" color="primary" />
        <Typography>Select a sample to view details</Typography>
      </Stack>
    </Stack>
  )
}
